module.exports = __webpack_public_path__ + "static/media/seat.b76d1ca6.svg";